import React from "react";
import classNames from "classnames";

import "./MenuList.scss";

const HeaderMenuList = ({ className, children }) => (
    <div className={classNames("menu-list", className)}>
        { children }
    </div>
);

export default HeaderMenuList;
